import { LocalizedText } from '@mews/framework';
import { Typography, Body } from '@optimus-web/core';
import { CardDetailListItemElement } from '../../styles';

const ConditionLabel = ({ conditionTextKey, conditionValue }: $TSFixMe) => (
    <CardDetailListItemElement>
        <Typography textStyle="bodySmallStrong" as="div">
            <LocalizedText textKey={conditionTextKey} />
        </Typography>
        <Body size="small">{conditionValue}</Body>
    </CardDetailListItemElement>
);

export default ConditionLabel;
